<div class="modal-header"><b>Selección de combustible</b></div>
<div class="modal-body">
    <div class="row align-items-center">
        <div [formGroup]="productoForm" class="col-md-10">
            <select class="form-select" id="productosFormControl" formControlName="productosFormControl">
                <option [value]="null" disabled>
                  Seleccione un combustible
                </option>
                <option [value]="producto.codigoProducto" *ngFor="let producto of productos">
                  {{ producto.nombreProducto }}
                </option>
            </select>
        </div>
        <div class="col-md-2">
            <button class="btn btn-success w-100 btn-small" [disabled]="!productosFormControl.value" (click)="agregarCombustible()">+</button>
        </div>
    </div>
    <div class="row align-items-center m-2" *ngFor="let productoSeleccionado of productosSeleccionados">
        <div class="col-md-10">{{ productoSeleccionado.nombreProducto }}</div>
        <div class="col-md-2">
            <button class="btn btn-small w-100 btn-danger ms-3 mt-2" (click)="eliminarCombustible(productoSeleccionado)"><i class="fa fa-trash"></i></button>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-primary" [disabled]="productosSeleccionados.length == 0" (click)="comenzarRecepcion()">Guardar</button>
    <button class="btn btn-secondary" (click)="this.activeModal.close(false)">Cerrar</button>
</div>
